enum ApiErrorTypes {
  OrganizationUnitMismatch = 'organization-unit-mismatch',
  RemovedItemConnectedToNotRemovedItem = 'removed-item-connected-to-not-removed-item',
}

export default ApiErrorTypes;
